// Loads the deck library manifest (manifest.json at the site root).
// Used by the boot screen to populate the deck picker.

export async function loadManifest() {
  const res = await fetch('/manifest.json', { cache: 'no-store' });
  if (!res.ok) return { decks: [] };
  return res.json();
}
